<div class="redSquare" (click)="onPress()">
    <mat-icon class="white-icon" aria-hidden="false" aria-label="X Icon">close</mat-icon>
</div>
<p class="text" *ngIf="text">{{ text }}</p>
